import classNames from "classnames";
import React, { ReactNode } from "react";
import styles from "./styles.module.css";

interface Props {
  children: ReactNode;
  className?: string;
  noMargin?: boolean;
  withGrid?: boolean;
}

export const ListContainer: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  noMargin,
  withGrid,
}) => (
  <ul
    className={classNames(
      styles.ul,
      withGrid ? styles.grid : null,
      noMargin ? styles.noMargin : null,
      className,
    )}
  >
    {children}
  </ul>
);
